import { API_REQUEST, GET_NSA_LIST } from "../../../config/constants";

const initialState = {

};
export default function NsaListReducer(state = initialState, action) {
    switch (action.type) {
        case API_REQUEST:
            return {
                ...state,
                loading: true
            };
        case GET_NSA_LIST:
            return {
                ...state,
                loading: false,
                NsaLsit: action.payload
            }
        default:
            return state;
    }
}